// extracted by mini-css-extract-plugin
export default {"button":"EqjfY","readMore":"wFCj7","container":"E2MVT","mobile-container":"Vr08U","mobileContainer":"Vr08U","wrapper":"_5H5nJ","readMoreExtraMargin":"l-PLC"};